/**
 * Hook for user logout
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@ui/use-toast';
import { logoutUser } from '@lib/api/auth';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: logoutUser,
    onSuccess: () => {
      // Clear the currentUser from cache
      queryClient.setQueryData(['currentUser'], null);
      // Invalidate any queries that depend on authentication
      queryClient.invalidateQueries();

      toast({
        title: 'Logged Out',
        description: 'You have been successfully logged out.',
      });
    },
    onError: () => {
      toast({
        title: 'Logout Error',
        description: 'There was a problem logging out. Please try again.',
        variant: 'destructive',
      });
    },
  });
};
